import CardBase from "../../../../UI/Card/CardBase/CardBase";
import classes from "./RenewPlanCreditCard.module.scss";
import paymentCard from "../../../../../assets/images/payment_card.svg";
import * as helpers from "../../../../../helpers/index";
import { setAnalyticsClickDashCardMyPanelMoreInfo } from "../../../../../helpers/analyticsHelpers";
import { PROBRAIN_LINK } from "../../../../../constants/api";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as routes from "../../../../../constants/routes";

const RenewPlanCreditCard = ({ session }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={classes.RenewPlanCreditCard}>
      <div className={classes.Title}>
        { t("purchase.plan_automatically_renew")}
      </div>
      <div className={classes.Items}>
        <div>
          { t("purchase.identified_recurring_subscripition_credit_card")}
        </div>
        <div>
          { t("purchase.at_the_end_purchase_cycle_the_charge_debited")}
        </div>
        <div>{ t("purchase.your_afinando_plan_will_be_active_normally")}</div>
      </div>
      <button
        onClick={() => {
          navigate(routes.R_MY_ACCOUNT);
          setAnalyticsClickDashCardMyPanelMoreInfo({
            type: session.my_user.typeUser,
            profile: session?.my_user?.profile,
          });
        }}
        className={classes.BtnManage}
      >
        { t("purchase.manage_my_plan_card")}
      </button>
    </div>
  );
};
export default RenewPlanCreditCard;
